<template>
    <div class="chat-suggestions" v-if="suggestions.length > 0">
        <div class="suggestions-label">
            <span class="material-symbols-outlined">lightbulb</span>
            <span>Try asking:</span>
        </div>
        <div class="suggestions-list">
            <button
                v-for="suggestion in suggestions"
                :key="suggestion"
                class="suggestion-chip"
                @click="$emit('select', suggestion)"
                :disabled="disabled"
            >
                {{ suggestion }}
            </button>
        </div>
    </div>
</template>

<script>
/**
 * ChatSuggestions Component
 * Displays clickable suggestion chips for quick chat queries.
 */
export default {
    name: 'ChatSuggestions',
    props: {
        /** @type {string[]} Array of suggestion text to display */
        suggestions: {
            type: Array,
            default: () => [
                'Total unpaid billings',
                'Events this month',
                'Overdue invoices',
                'Upcoming events',
                'Recent payments',
            ],
        },
        /** @type {boolean} Whether suggestions are clickable */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['select'],
}
</script>

<style scoped>
.chat-suggestions {
    padding: 16px;
    background: var(--color-surface);
}

.suggestions-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: var(--color-outline);
    margin-bottom: 12px;
}

.suggestions-label .material-symbols-outlined {
    font-size: 16px;
    color: var(--color-primary);
}

.suggestions-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.suggestion-chip {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid var(--color-outline-variant);
    background: var(--color-surface-container-low);
    color: var(--color-on-surface);
    font-size: 13px;
    font-family: 'Manrope', sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.suggestion-chip:hover:not(:disabled) {
    background: var(--color-primary-fixed-dim);
    border-color: var(--color-primary);
    color: var(--color-on-primary-fixed);
}

.suggestion-chip:active:not(:disabled) {
    transform: scale(0.97);
}

.suggestion-chip:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>
